import toBool from 'utils/toBool'
import { z } from 'zod'
import { GenericManagerSchema } from '../GenericManagerTask/GenericManagerSchema'

const managerNonSurgicalAdmissionFields = z.object({
	exams: z
		.array(
			z
				.object({
					checked: z.boolean(),
					id: z.number(),
				})
				.strict()
		)
		.optional(),
	needEscort: z.boolean().optional().transform(toBool),
	medicalObservation: z.string().optional(),
	notes: z.string().optional(),
})

const NonSurgicalAdmissionFields = z.object({
	exams: z
		.array(
			z
				.object({
					checked: z.boolean(),
					id: z.number(),
				})
				.strict()
		)
		.optional(),
	notes: z.string().optional(),
	needEscort: z.boolean().optional().transform(toBool),
	medicalObservation: z.string().optional(),
	/*urgency: z
		.string()
		.transform((elem) => parseInt(elem, 10))
		.refine((elem) => elem > 0 && elem < 4, {
			message: 'Invalid option',
			path: ['urgency'],
		}),*/
})

export const strictSchema = (args) => {
	return NonSurgicalAdmissionFields.strict().refine(
		(data) => !args?.requestEscort || data?.needEscort !== undefined,
		{
			message: 'Required',
			path: ['needEscort'],
		}
	)
}

export const NonSurgicalAdmissionSchema = (args) => strictSchema(args)

export const ExtendedNonSurgicalAdmissionSchema = (args) =>
	z.intersection(
		GenericManagerSchema(args),
		managerNonSurgicalAdmissionFields
	)
